'use client'

import Modal from '@crystal-eyes/components/elements/Modal'
import styles from './KnowYourTypeModal.module.scss'
import MbtiKnowType from '../sections/assessments/MbtiKnowType'
import EnneagramKnowType from '../sections/assessments/EnneagramKnowType'
import useKnowYourType from '../hooks/useKnowYourType'

interface Identity {
  id: string
}

type Props = { identity?: Identity }

const KnowYourTypeModal = ({ identity }: Props) => {
  const {
    entryState: { knowType, setKnowType },
  } = useKnowYourType()
  if (knowType === 'none') return null
  return (
    <Modal
      className={styles.knowYourTypeModal}
      close={() => {
        setKnowType('none')
      }}
    >
      {knowType === 'mbti' && (
        <MbtiKnowType onFinish={() => setKnowType('none')} />
      )}
      {knowType === 'enneagram' && (
        <EnneagramKnowType
          identity={identity}
          onFinish={() => setKnowType('none')}
        />
      )}
    </Modal>
  )
}

export default KnowYourTypeModal
